
import React from "react";
import { useStaticText } from "./useStaticText";
import StaticTextHeader from "./StaticTextHeader";
import StaticTextFilters from "./StaticTextFilters";
import StaticContentList from "./StaticContentList";
import StaticTextLoading from "./StaticTextLoading";

const StaticTextModule: React.FC = () => {
  const {
    isLoading,
    searchTerm,
    setSearchTerm,
    selectedPage,
    setSelectedPage,
    selectedSection,
    setSelectedSection,
    pages,
    sections,
    filteredContents,
    editingId,
    editedContent,
    setEditedContent,
    isSaving,
    loadStaticContent,
    handleEdit,
    handleCancelEdit,
    handleSave
  } = useStaticText();

  if (isLoading) {
    return <StaticTextLoading />;
  }

  return (
    <div className="p-6">
      {/* Page Header */}
      <StaticTextHeader loadStaticContent={loadStaticContent} />
      
      {/* Filters */}
      <StaticTextFilters
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        selectedPage={selectedPage}
        setSelectedPage={setSelectedPage}
        selectedSection={selectedSection}
        setSelectedSection={setSelectedSection}
        pages={pages}
        sections={sections}
      />
      
      {/* Content List */}
      <StaticContentList
        filteredContents={filteredContents}
        editingId={editingId}
        editedContent={editedContent}
        setEditedContent={setEditedContent}
        isSaving={isSaving}
        handleEdit={handleEdit}
        handleCancelEdit={handleCancelEdit}
        handleSave={handleSave}
        searchTerm={searchTerm}
        selectedPage={selectedPage}
        selectedSection={selectedSection}
      />
    </div>
  );
};

export default StaticTextModule;
